const dayKey = (value) => {
  const m = String(value || "").match(/(\d{4})-(\d{2})-(\d{2})/);
  return m ? new Date(+m[1], +m[2] - 1, +m[3]).getTime() : null;
};

export const sortByPaymentDate = (rows) => {
  if (!Array.isArray(rows)) return rows;
  return [...rows].sort((a, b) => {
    const da = dayKey(a && a.payment_date);
    const db = dayKey(b && b.payment_date);
    if (da !== db) {
      if (da === null) return 1;
      if (db === null) return -1;
      return da - db;
    }
    return (Number(a && a.client_id) || 0) - (Number(b && b.client_id) || 0);
  });
};
